import routes from './routes'
import RouterController from '@/router/routerController'

const router = new RouterController(routes)

export default router
